import store from '@/store/index'
import { contractorPermsTypes } from '@/utils/aclHelper'
import { getVendorDetailByIdAndSite } from '../users/request'
import { getVendorSubEmailsByRight } from './util'

export async function getEmailDetailByIdAndSite (vendorId, siteCode) {
  const [vendorDetail, vendorSubAccounts] = await getVendorDetailByIdAndSite(vendorId, siteCode)
  const subAccountEmails = getVendorSubEmailsByRight(vendorSubAccounts, contractorPermsTypes.tenders.readUpdate)
  return [vendorDetail, subAccountEmails]
}

export async function getVendorDetailAndSubEmails (siteCode) {
  const currentUser = store.getters['user/currentUser']
  const vendorId = currentUser.externalId
  return getEmailDetailByIdAndSite(vendorId, siteCode)
}
